const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const MatchingSetPendingReportQueryURL: any = {
    GetMatchingSetPendingProducts: Backofficebff + '/v1/matching-set-pending-products/query',
};
